<template>
	<main class="terms">
		<article class="terms_info">
			<h6>서비스 이용약관</h6>
			<div
				v-dompurify-html="terms?.data.terms.tos_content ?? '서비스 이용약관 불러오는 중'"
				class="content_body c_editorContent"
			></div>
		</article>
	</main>
</template>

<script setup lang="ts">
// api
// core
import { ref, watch } from 'vue';

import { useGetTermsApi } from '@/api/mypage';
// util
import { handleLinkClick } from '@/utils/directive/editorLinkOpenNewTab';

// -----variable-----
const contentBody = ref<HTMLDivElement | null>(null);
// -----api-----
const { data: terms } = useGetTermsApi({ tos_type: 'service' });

//editor 링크 클릭 시 새창 열기
// COMMENT : AOS에서는 target: _blank로 새창을 띄울 수 없어 추가된 코드입니다.
watch(
	[terms],
	() => {
		contentBody.value = document.querySelector('.c_editorContent');

		if (contentBody.value) {
			// 기존 리스너 제거
			contentBody.value.removeEventListener('click', handleLinkClick);

			// 새로운 리스너 추가
			contentBody.value.addEventListener('click', handleLinkClick);
		}
	},
	{ immediate: true }
);
</script>

<style lang="scss" scoped>
.terms {
	max-width: 60rem;
	width: 100%;
	margin: 0 auto;
	padding-top: var(--header-height);
	margin-top: 8rem;
	margin-bottom: 2rem;
	@media screen and (max-width: 1280px) {
		margin-top: 4rem;
		padding: var(--header-height) 2rem 0rem 2rem;
	}
	.terms_info {
		display: flex;
		flex-direction: column;
		gap: var(--space-xxx-large);
		.content_body {
			font-weight: var(--font-w-light);
			font-size: var(--font-s-regular);
			line-height: 2.3rem;
		}
	}
}
</style>
